import script from "./ChatRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatRoom.vue?vue&type=script&setup=true&lang=js"

import "./ChatRoom.vue?vue&type=style&index=0&id=244169c6&lang=scss"

const __exports__ = script;

export default __exports__